<template>
  <b-container fluid class="no-bottom">
    <b-row>
      <b-col class="d-flex">
        <backlink v-if="!this.product_id" class="mt-20" />
        <div class="flex-grow-1">
          <h1>
            <div v-if="!isBusy" class="subtitle">#{{ values.name }}</div>
          </h1>
        </div>
      </b-col>
    </b-row>

    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center">Les données sont en cours de chargement...</p>
    <b-row v-else>
      <b-col>
        <div class="ibox">
          <div class="ibox-content divided">
            <b-row v-if="rawValues.type == 'selling'">
              <b-col class="d-flex">
                <div class="pr-120">
                  <h3>{{ labels.sale_price }}</h3>
                </div>
                <div class="prices-list flex-grow-1 d-flex">
                  <div class="price flex-fill active">
                    <dl>
                      <dd>{{ values.sale_price ? parseFloat(values.sale_price).toFixed(2) + "€" : null }}</dd>
                    </dl>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="picture">
              <b-col>
                <img :src="picture" class="w-100" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-row>
                  <b-col>
                    <dl>
                      <dt>{{ labels.internal_code }} :</dt>
                      <dd>{{ values.internal_code || '-' }}</dd>
                      <dt>{{ labels.stock_mini }} :</dt>
                      <dd>{{ values.stock_mini }}</dd>
                      <template v-if="rawValues.type == 'selling'">
                        <dt>{{ labels.purchase_price }} :</dt>
                        <dd>{{ values.purchase_price || '-' }}</dd>
                        <dt>{{ labels.supplier }} :</dt>
                        <dd>{{ values.supplier || '-' }}</dd>
                        <dt>{{ labels.brand }} :</dt>
                        <dd>{{ values.brand || '-' }}</dd>
                        <dt>{{ labels.model }} :</dt>
                        <dd>{{ values.model || '-' }}</dd>
                      </template>
                      <template v-else-if="rawValues.type == 'renting'">
                        <dt>{{ labels.equipment_group }} :</dt>
                        <dd>{{ values.equipment_group }}</dd>
                        <dt>{{ labels.calibration_periodicity }} :</dt>
                        <dd>{{ values.calibration_periodicity }}</dd>
                        <dt>{{ labels.calibration_provider }} :</dt>
                        <dd>
                          <router-link v-if="rawValues.calibration_provider"
                            :to="{ name: 'CompanyDetail', params: { id: rawValues.calibration_provider.id } }">{{
          values.calibration_provider }}</router-link>
                        </dd>
                      </template>
                      <dt>{{ labels.group_slug }} :</dt>
                      <dd>{{ values.group_slug || '-' }}</dd>
                      <dt>{{ labels.comment }} :</dt>
                      <dd class="nl2br">{{ values.comment || '-' }}</dd>
                    </dl>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- Environnement de stockage du produit, par entrepôt (le sien seul pour un utilisateur mono-entrepôt) -->
            <b-row v-if="rawValues.type != 'selling' && storages.length">
              <b-col class="d-flex flex-column">
                <h3>Stockage</h3>
                <ul class="storage_location">
                  <li v-for="storage in storages" :key="storage.warehouse_id">{{ storageLabel(storage) }}</li>
                </ul>
              </b-col>
            </b-row>
            <b-row v-if="rawValues.type == 'selling'">
              <b-col class="d-flex flex-column">
                <h3>Stockage</h3>
                <div class="storage_location flex-grow-1 d-flex flex-column justify-content-center flex-nowrap">
                  <ul v-if="storages.length">
                    <li v-for="storage in storages" :key="storage.warehouse_id">{{ storageLabel(storage) }}</li>
                  </ul>
                  <b-badge :variant="values.stock <= 0 ? 'danger' : 'success'">{{ labels.stock }} : {{ values.stock
                    }}</b-badge>
                </div>
              </b-col>
              <b-col class="d-flex flex-column barcode-col">
                <h3>Code barre</h3>
                <b-row class="flex-grow-1 flex-column barcode-wrapper justify-content">
                  <div class="text-center">
                    <div>{{ values.internal_code }}</div>
                  </div>
                  <div class="text-center">
                    <div>{{ values.name }}</div>
                  </div>
                  <barcode class="text-center" :value="values.internal_code" :displayValue="false" height="50">
                    Impossible de générer
                    le code à barres</barcode>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-else-if="rawValues.type == 'renting'">
              <b-col>
                <h3>Stockage</h3>
                <ul>
                  <li>
                    <b-badge
                      :variant="rawValues.stock <= 0 ? 'danger' : rawValues.stock <= rawValues.minimum_stock ? 'warning' : 'success'">{{
          labels.stock }} : {{
          rawValues.stock }}</b-badge>
                  </li>
                  <li>
                    <b-badge :variant="rawValues.stock > 0 ? 'success' : null">{{ rawValues.rent_count }} {{
          labels.rent_count ?
            labels.rent_count.toLowerCase() : null }}</b-badge>
                  </li>
                  <li>
                    <b-badge :variant="rawValues.maintenance_count > 0 ? 'warning' : 'success'">{{
          rawValues.maintenance_count }} {{
          labels.maintenance_count ? labels.maintenance_count.toLowerCase() : null }}</b-badge>
                  </li>
                  <li>
                    <b-badge :variant="rawValues.lost_count > 0 ? 'danger' : 'success'">{{ rawValues.lost_count }} {{
          labels.lost_count ? labels.lost_count.toLowerCase() : null }}</b-badge>
                  </li>
                  <li>
                    <b-badge :variant="rawValues.trash_count > 0 ? 'danger' : 'success'">{{ rawValues.trash_count }} {{
          labels.trash_count ? labels.trash_count.toLowerCase() : null }}</b-badge>
                  </li>
                </ul>
              </b-col>
            </b-row>
            <b-row
              v-if="rawValues.type == 'renting' && rawValues.unique_references && rawValues.unique_references.length">
              <b-col>
                <h3>
                  <i class="far fa-wrench"></i> Références uniques
                </h3>
                <div class="table-wrapper">
                  <b-table hover :fields="reference_fields" :items="referencesItems">
                    <template slot="internal_code" slot-scope="data">
                      <strong>{{ data.value }}</strong>
                    </template>
                    <template slot="status" slot-scope="data">
                      <b-badge variant="primary">{{ data.value }}</b-badge>
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import config from "./config";
import reference_config from "@/components/Reference/config";
import { environmentLabel } from "@/components/StorageEnvironment/labels";

export default {
  name: "ProductMobileDetail",
  props: ["product_id"],
  data() {
    return {
      config: config,
      reference_config: reference_config,
      labels: {},
      reference_fields: [],
      storages: [],
      isBusy: false,
      id_to_edit: null,
    };
  },
  computed: {
    rawValues: function () {
      return (
        this.$store.getters[config.storeNamespace + "/getItem"](
          this.product_id || this.$route.params.id
        ) || {}
      );
    },
    values: function () {
      return this.$root.formatData(
        this.rawValues,
        this.config.fields.filter((field) => field.inDetail == true)
      );
    },
    picture() {
      return this.values.picture ? process.env.BACK_FILES_URL + "300/" + this.values.picture : null;
    },
    referencesItems: function () {
      return this.rawValues.unique_references
        ? this.$root.formatDatas(
            this.rawValues.unique_references,
            this.reference_config.fields.filter((field) => field.inDetail == true)
          )
        : [];
    },
  },
  mounted() {
    // Chargement des champs à afficher dans le détail depuis la config
    // Et récupération des libellés
    config.fields
      .filter((field) => field.inDetail == true)
      .forEach((field) => {
        this.labels[field.name] = field.label;
      });

    this.getProduct();

    // Préparation des champs pour les listes des références
    let reference_fields = reference_config.fields
      .filter((field) => ["internal_code", "status"].includes(field.name))
      .map((field) => ({
        key: field.name,
        label: field.label,
      }));
    this.reference_fields = reference_fields;
  },
  watch: {
    product_id: function (product_id) {
      this.getProduct();
    },
  },
  methods: {
    /**
     * Charge le produit passé en attribut
     */
    getProduct() {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: this.product_id || this.$route.params.id,
          wait: true,
        })
        .then(() => {
          this.isBusy = false;
        });
      this.loadStorages();
    },
    loadStorages() {
      this.$http
        .get(process.env.BACK_API_URL + "product/" + (this.product_id || this.$route.params.id) + "/storages/by-warehouse")
        .then((response) => {
          this.storages = response.data.storages || [];
        })
        .catch(() => {
          this.storages = [];
        });
    },
    storageLabel(storage) {
      return environmentLabel(storage);
    },
  },
};
</script>

<style lang="scss">
.barcode-wrapper> :nth-child(1) {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductMobile/ProductMobileDetail.vue